export default {
  singleLine: (categoryName) => {
    return categoryName.replace(new RegExp('/', 'g'), '>').replace(new RegExp('>$'), '');
  },
  multiLine: (categoryName) => {
    return categoryName.replace(new RegExp('/$'), '').replace(new RegExp('/', 'g'), '>/').split('/');
  },
};
